document.documentElement.classList.remove('no-js');

const navToggle = document.querySelector('[data-nav-toggle]');
const mobileNav = document.querySelector('[data-mobile-nav]');

if (navToggle && mobileNav) {
  navToggle.addEventListener('click', () => {
    const isOpen = navToggle.getAttribute('aria-expanded') === 'true';
    navToggle.setAttribute('aria-expanded', String(!isOpen));
    mobileNav.hidden = isOpen;
    document.body.classList.toggle('nav-open', !isOpen);
  });
}

document.querySelectorAll('[data-quantity-control]').forEach((control) => {
  const input = control.querySelector('input[type="number"]');
  control.querySelectorAll('button').forEach((button) => {
    button.addEventListener('click', () => {
      const amount = button.dataset.action === 'increase' ? 1 : -1;
      const minimum = Number(input.min || 1);
      input.value = Math.max(minimum, Number(input.value || minimum) + amount);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});

const revealObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 })
  : null;

document.querySelectorAll('[data-reveal]').forEach((element) => {
  if (revealObserver) revealObserver.observe(element);
  else element.classList.add('is-visible');
});
